var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPersistent(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3810_52945)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M43.0671 102.158H29.0781V116.147H43.0671V102.158Z",
    stroke: "#1E2146",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.0561 102.158H43.0671V116.147H57.0561V102.158Z",
    stroke: "#1E2146",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.0451 102.158H57.0562V116.147H71.0451V102.158Z",
    stroke: "#1E2146",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.0342 102.158H71.0452V116.147H85.0342V102.158Z",
    stroke: "#1E2146",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.0232 102.158H85.0342V116.147H99.0232V102.158Z",
    stroke: "#1E2146",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.012 102.158H99.0232V116.147H113.012V102.158Z",
    stroke: "#1E2146",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.0552 88.1692H36.0662V102.158H50.0552V88.1692Z",
    stroke: "#1E2146",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.0442 88.1692H50.0552V102.158H64.0442V88.1692Z",
    stroke: "#1E2146",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.0332 88.1692H64.0442V102.158H78.0332V88.1692Z",
    stroke: "#1E2146",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.0222 88.1692H78.0332V102.158H92.0222V88.1692Z",
    stroke: "#1E2146",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.011 88.1692H92.022V102.158H106.011V88.1692Z",
    stroke: "#1E2146",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120 88.1692H106.011V102.158H120V88.1692Z",
    stroke: "#1E2146",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.0561 74.1802H43.0671V88.1692H57.0561V74.1802Z",
    stroke: "#1E2146",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.0451 74.1802H57.0562V88.1692H71.0451V74.1802Z",
    stroke: "#1E2146",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.0342 74.1802H71.0452V88.1692H85.0342V74.1802Z",
    stroke: "#1E2146",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.0232 74.1802H85.0342V88.1692H99.0232V74.1802Z",
    stroke: "#1E2146",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.012 74.1802H99.0232V88.1692H113.012V74.1802Z",
    stroke: "#1E2146",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.0442 60.1914H50.0552V74.1804H64.0442V60.1914Z",
    stroke: "#1E2146",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.0332 60.1914H64.0442V74.1804H78.0332V60.1914Z",
    stroke: "#1E2146",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.0222 60.1914H78.0332V74.1804H92.0222V60.1914Z",
    stroke: "#1E2146",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.011 60.1914H92.022V74.1804H106.011V60.1914Z",
    stroke: "#1E2146",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120 60.1914H106.011V74.1804H120V60.1914Z",
    stroke: "#1E2146",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.0451 46.2024H57.0562V60.1914H71.0451V46.2024Z",
    stroke: "#1E2146",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.0342 46.2024H71.0452V60.1914H85.0342V46.2024Z",
    stroke: "#1E2146",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.0232 46.2024H85.0342V60.1914H99.0232V46.2024Z",
    stroke: "#1E2146",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.012 46.2024H99.0232V60.1914H113.012V46.2024Z",
    stroke: "#1E2146",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.0332 32.2134H64.0442V46.2024H78.0332V32.2134Z",
    stroke: "#1E2146",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.0781 102.158H15.0891V116.147H29.0781V102.158Z",
    stroke: "#1E2146",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.0771 94.8556V95.6947V102.158H36.0661V88.7723V88.1692H25.9054H25.6694H24.6862H24.5682H23.598",
    stroke: "#1E2146",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.0671 74.1802H29.0781V88.1692H43.0671V74.1802Z",
    stroke: "#1E2146",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.0552 60.1914H36.0662V74.1804H50.0552V60.1914Z",
    stroke: "#1E2146",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.0561 46.2024H43.0671V60.1914H57.0561V46.2024Z",
    stroke: "#1E2146",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.0442 32.2134H50.0552V46.2024H64.0442V32.2134Z",
    stroke: "#1E2146",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.0222 32.2134H78.0332V46.2024H92.0222V32.2134Z",
    stroke: "#1E2146",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.011 32.2134H92.022V46.2024H106.011V32.2134Z",
    stroke: "#1E2146",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.0232 18.2244H85.0342V32.2134H99.0232V18.2244Z",
    stroke: "#1E2146",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.0342 18.2244H71.0452V32.2134H85.0342V18.2244Z",
    stroke: "#1E2146",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.0451 18.2244H57.0562V32.2134H71.0451V18.2244Z",
    stroke: "#1E2146",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.011 4.23535H92.022V18.2243H106.011V4.23535Z",
    stroke: "#1E2146",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.0222 4.23535H78.0332V18.2243H92.0222V4.23535Z",
    stroke: "#1E2146",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120 32.2134H106.011V46.2024H120V32.2134Z",
    stroke: "#1E2146",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.012 18.2244H99.0232V32.2134H113.012V18.2244Z",
    stroke: "#1E2146",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120 18.2244H113.012V32.2134H120V18.2244Z",
    stroke: "#1E2146",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120 46.2024H113.012V60.1914H120V46.2024Z",
    stroke: "#1E2146",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120 74.1802H113.012V88.1692H120V74.1802Z",
    stroke: "#1E2146",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120 102.158H113.012V116.147H120V102.158Z",
    stroke: "#1E2146",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120 4.23535H106.011V18.2243H120V4.23535Z",
    stroke: "#1E2146",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.0413 70.6142C21.0676 70.7322 21.0938 70.8633 21.1593 70.9682C21.2642 71.1386 21.4347 71.2435 21.6313 71.2697C21.828 71.2828 22.0115 71.178 22.1033 71.0075C22.1688 70.8895 22.1951 70.7453 22.182 70.6011C22.1688 70.5093 22.1688 70.4175 22.1557 70.3389C22.1557 70.2078 22.1557 70.0767 22.1295 69.9456C22.1033 69.8013 22.064 69.6309 21.9722 69.4998C21.9329 69.4474 21.8935 69.3949 21.8411 69.3556L21.8149 69.3162C21.6969 69.1851 21.5002 69.1196 21.3298 69.1851C21.1593 69.2376 21.0413 69.3818 20.9889 69.5522C20.8971 69.8144 20.9364 70.1291 20.9889 70.3913C21.002 70.47 21.0151 70.5486 21.0413 70.6142Z",
    fill: "#1E2146"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.9356 72.1352C14.0011 72.0172 14.0273 71.873 14.0142 71.7288C14.0011 71.637 14.0011 71.5452 13.988 71.4666C13.988 71.3354 13.988 71.2043 13.9618 71.0732C13.9356 70.929 13.8962 70.7586 13.8045 70.6275C13.7651 70.575 13.7258 70.5226 13.6734 70.4833L13.6471 70.4439C13.5291 70.3128 13.3325 70.2473 13.162 70.3128C12.9916 70.3653 12.8736 70.5095 12.8212 70.6799C12.7294 70.9421 12.7687 71.2568 12.8212 71.519C12.8343 71.5845 12.8605 71.6632 12.8867 71.7288C12.9129 71.8468 12.9392 71.9779 13.0047 72.0828C13.1096 72.2532 13.28 72.3581 13.4767 72.3843C13.6602 72.4105 13.8438 72.2925 13.9356 72.1352Z",
    fill: "#1E2146"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.0163 74.0493C17.331 74.1673 17.6981 74.2198 18.0259 74.1804C18.4323 74.1411 18.8256 74.01 19.1534 73.7609C19.4287 73.5642 19.8089 73.2758 19.8351 72.9218C19.8351 72.8432 19.7696 72.8038 19.704 72.8169C19.5336 72.8432 19.4156 72.9349 19.2845 73.0267C19.1534 73.1185 19.0223 73.184 18.8781 73.2496C18.6158 73.3545 18.3274 73.4594 18.039 73.4987C17.7768 73.5249 17.5014 73.4987 17.2523 73.4069C17.0032 73.3151 16.8459 73.1447 16.6361 72.9743C16.3477 72.7252 15.8888 73.0398 16.0986 73.3938C16.2953 73.7085 16.6624 73.9182 17.0163 74.0493Z",
    fill: "#1E2146"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.9458 91.198C32.9458 90.8046 32.1723 90.7915 31.6216 90.8309C31.4512 90.8571 31.2939 90.8702 31.1234 90.8833C31.1234 90.8833 31.1234 90.8833 31.1103 90.8833C31.071 90.8833 31.0316 90.8833 31.0054 90.8964C30.9399 90.8964 30.8874 90.9226 30.8481 90.962C30.835 90.9751 30.8219 90.9882 30.8088 91.0013C30.6383 90.9751 30.4679 90.962 30.2843 90.9751C30.127 90.9751 29.9828 91.0013 29.8255 91.0275C29.7206 91.0406 29.6288 91.0668 29.537 91.08C29.4321 91.1062 29.3142 91.1193 29.2093 91.1455C28.8684 91.2111 28.5406 91.2766 28.1998 91.3553C27.6491 91.4733 26.9805 91.5126 26.4954 91.801C26.4692 91.8142 26.4429 91.8404 26.4167 91.8666L26.1676 91.6175L25.9185 91.3553C25.7743 91.1848 25.6301 91.0275 25.4859 90.8571C25.4465 90.8046 25.4072 90.7653 25.3679 90.7129C25.1843 89.9131 24.8434 89.1265 24.4763 88.3923C24.3584 88.1694 24.2404 87.9465 24.1224 87.7237C23.9257 87.3566 23.7159 86.9895 23.4931 86.6224C22.2344 84.5771 20.6874 82.7285 19.1272 80.9193C19.1535 80.9061 19.1666 80.893 19.1928 80.8799C19.1928 80.893 19.1928 80.893 19.2059 80.9062C20.0581 81.8632 20.9496 82.7941 21.7756 83.7643C22.182 84.2493 22.5753 84.7475 22.9686 85.2458C23.1522 85.4949 23.3357 85.744 23.5193 85.9931C23.6373 86.1504 23.7422 86.347 23.8864 86.5044C23.9519 86.583 24.0437 86.6486 24.1355 86.701C24.1486 86.701 24.1486 86.7141 24.1617 86.7141C24.201 86.7272 24.2272 86.7272 24.2535 86.7404L24.1093 86.4519L23.9519 86.1373L23.1391 84.5378C22.8113 84.1576 22.4967 83.7774 22.1558 83.4103C21.3036 82.4663 20.4252 81.5617 19.4419 80.7619C20.2547 80.3162 21.002 79.7918 21.6707 79.2018C21.8149 79.0707 21.9722 78.9396 22.1033 78.7953C22.1164 78.7822 22.1296 78.7691 22.1427 78.756C23.965 76.9468 25.0663 74.6262 25.0663 72.1614C25.0663 71.7943 25.0401 71.4141 24.9877 71.0339C24.6599 68.6084 23.2833 66.5501 21.3167 65.1079C19.3501 63.6657 16.7673 62.8267 13.9879 62.8267C13.3586 62.8267 12.7162 62.866 12.0737 62.9578C9.12386 63.3642 6.54108 64.6621 4.69248 66.4714C2.84389 68.2807 1.72949 70.6143 1.72949 73.1054C1.72949 73.4725 1.75571 73.8527 1.80816 74.2329C1.97859 75.439 2.39813 76.5666 3.02744 77.563C3.65675 78.5594 4.49582 79.4378 5.47912 80.1588C7.44571 81.601 10.0285 82.4401 12.8079 82.4401C13.0308 82.4401 13.2668 82.427 13.4897 82.427C13.5028 83.62 13.6339 84.8131 13.7388 85.9931C13.8174 86.819 13.883 87.645 13.9617 88.471C14.0141 89.1134 14.0797 89.7427 14.1452 90.3851C14.2632 91.6175 14.2108 93.0728 14.827 94.1872C15.3514 95.1311 16.2822 95.6162 17.318 95.7867C17.5146 96.9273 17.7506 98.0548 17.8817 99.2085C17.0295 98.907 16.1642 98.6579 15.2989 98.3826C14.8532 98.2383 14.3812 98.081 13.9354 98.2908C13.5815 98.4612 13.3979 98.8283 13.3455 99.1954C13.2406 100.048 13.6995 101.018 14.1059 101.726C14.3156 102.093 14.6434 102.46 15.0892 102.525C15.4956 102.591 15.8627 102.355 16.0462 102.014C16.4396 101.28 16.3085 100.27 15.9938 99.4707C16.7411 99.7067 17.5015 99.9558 18.2619 100.152C18.511 100.218 18.7208 99.9296 18.6946 99.7067C18.511 98.4219 18.2882 97.0715 17.8686 95.826C18.8257 95.9047 19.8221 95.7998 20.7661 95.6949C21.5134 95.6162 22.2738 95.4589 22.9686 95.1705C23.4668 96.2718 24.1355 97.2944 24.7517 98.3301C25.0794 98.8808 25.4203 99.4445 25.7481 99.9952C26.0103 100.441 26.2594 100.9 26.6527 101.267C27.4262 101.988 28.5275 101.857 29.4715 101.673C30.3368 101.516 31.2283 101.175 31.6085 100.323C31.7265 100.074 31.5298 99.8509 31.307 99.7985C29.7206 99.4183 28.1211 99.3003 26.4954 99.5625C26.456 99.5625 26.4298 99.5756 26.4036 99.5887C25.4072 98.0417 24.5157 96.4029 23.3619 94.9738C23.6373 94.8296 23.9126 94.6591 24.1617 94.4494C24.9352 93.807 25.381 92.9548 25.4596 91.9977C26.2856 92.9023 27.2296 93.7021 28.462 94.0167C29.2486 94.2134 30.127 94.1741 30.8481 93.7676C31.071 93.6365 31.2807 93.4792 31.4381 93.2825C31.5561 93.2694 31.6741 93.2563 31.7789 93.217C32.0412 93.1252 32.2771 92.9548 32.4738 92.7581C32.6705 92.5615 32.8147 92.2992 32.8933 92.037C32.9327 91.8928 32.972 91.7617 32.972 91.6175C32.9851 91.4864 32.9851 91.3291 32.9458 91.198ZM15.3121 101.621C15.1023 101.896 14.7876 101.241 14.709 101.096C14.5123 100.703 14.3288 100.284 14.2239 99.8509C14.1714 99.6412 14.0665 99.2479 14.237 99.0643C14.3681 98.9201 14.6565 98.9988 14.9318 99.0905C14.9318 99.1299 14.9581 99.1823 14.9843 99.2347C15.2072 99.6281 15.3514 100.034 15.4169 100.48C15.4432 100.782 15.5087 101.346 15.3121 101.621ZM30.5859 100.388C30.1532 100.716 29.4846 100.808 28.9864 100.887C28.5669 100.952 28.1211 101.031 27.7016 100.926C27.3345 100.834 27.0854 100.585 26.8756 100.297C28.0949 100.113 29.3797 100.113 30.5859 100.388ZM22.5753 86.8321L22.5884 86.8452C22.9424 87.3828 23.2702 87.9465 23.5586 88.5234C23.1128 87.999 22.6671 87.4614 22.2213 86.937C21.7887 86.4257 21.356 85.9013 20.9103 85.39C20.281 84.6427 19.6517 83.8954 19.0223 83.1481C18.5766 82.6105 18.1308 82.0468 17.6326 81.5355C17.8293 81.4568 18.0259 81.3912 18.2095 81.2995C19.7565 83.0825 21.3036 84.8655 22.5753 86.8321ZM24.1224 71.1388C24.1748 71.4796 24.1879 71.8074 24.1879 72.1483C24.1879 74.364 23.1915 76.501 21.474 78.1792C20.9234 78.7167 20.2941 79.2149 19.6123 79.6475C18.1702 80.5522 16.4658 81.1946 14.5779 81.4568C14.2763 81.4961 13.9748 81.5223 13.6732 81.5486C13.6208 81.5223 13.5552 81.5224 13.5028 81.5617C13.2537 81.5748 13.0177 81.5879 12.7686 81.5879C10.1596 81.5879 7.76036 80.8013 5.93799 79.464C4.12873 78.1267 2.89633 76.265 2.6079 74.1018C2.55546 73.7609 2.54235 73.4331 2.54235 73.0922C2.54235 70.8766 3.53875 68.7395 5.25624 67.0614C6.96061 65.3832 9.37296 64.1639 12.1524 63.7837C12.7555 63.7051 13.3586 63.6657 13.9486 63.6657C16.5576 63.6657 18.9699 64.4524 20.7792 65.7897C21.9722 66.6681 22.9162 67.7825 23.5062 69.0542C23.8077 69.6966 24.0175 70.3915 24.1224 71.1388ZM24.1748 93.2301C23.5193 94.1347 22.4442 94.5674 21.3691 94.764C20.3203 94.9607 19.1928 95.0656 18.1308 95.0262C17.2262 94.9869 16.2298 94.8034 15.6529 94.043C14.9581 93.1121 14.9974 91.6962 14.8794 90.5949C14.8007 89.8476 14.7221 89.1003 14.6434 88.353C14.5648 87.6188 14.4861 86.8715 14.4074 86.1373C14.2632 84.8787 14.1583 83.6069 13.9092 82.3614C14.1714 82.3352 14.4336 82.309 14.6959 82.2828C15.5349 82.1648 16.3347 81.9812 17.0951 81.7321C17.5277 82.3876 18.0784 83.0038 18.5635 83.6069C19.2059 84.4067 19.8483 85.1933 20.5038 85.9931C20.8185 86.3733 21.1332 86.7666 21.4478 87.1468C22.4442 88.3661 23.4406 89.5854 24.437 90.8046C24.4632 90.844 24.4895 90.8702 24.5157 90.9095C24.6992 91.6962 24.6861 92.5221 24.1748 93.2301ZM29.7861 93.2694C29.0782 93.3743 28.344 93.1777 27.7147 92.8499C27.4918 92.7319 27.2951 92.6008 27.0985 92.4566C27.3213 92.4172 27.5442 92.3648 27.7802 92.3124C28.226 92.2075 28.6848 92.1026 29.1306 91.9977C29.6026 91.8797 30.8612 91.3553 31.0579 92.0764C31.2414 92.7843 30.3368 93.1908 29.7861 93.2694ZM32.4476 91.8928C32.3951 92.1157 32.2771 92.3124 32.1329 92.4828C32.028 92.6008 31.8969 92.7057 31.7527 92.7843C31.8445 92.5352 31.8838 92.2468 31.8183 91.9584C31.7658 91.7355 31.6872 91.5651 31.5823 91.4208C31.8838 91.3815 32.1854 91.3422 32.4869 91.2897C32.4869 91.3815 32.5 91.4733 32.5 91.5651C32.4869 91.6699 32.4738 91.7879 32.4476 91.8928Z",
    fill: "#1E2146"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.3774 74.703L21.5598 78.9121L25.7689 91.7297L38.5865 87.5206L34.3774 74.703Z",
    fill: "white",
    stroke: "#1E2146",
    strokeMiterlimit: 10
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3810_52945"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 120,
    height: 120,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPersistent);
export default __webpack_public_path__ + "static/media/Persistent.ab7e0d2498b8482246815086b24c9b72.svg";
export { ForwardRef as ReactComponent };